import { Routes } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { MenuComponent } from './modules/menu/menu.component';
const ɵ0 = () => import("./modules/login/login.module.ngfactory").then(m => m.LoginModuleNgFactory), ɵ1 = () => import("./modules/bonos/bonos.module.ngfactory").then(m => m.BonosModuleNgFactory), ɵ2 = () => import("./modules/bono-ges/bono-ges.module.ngfactory").then(m => m.BonoGesModuleNgFactory), ɵ3 = () => import("./modules/reembolsos/reembolsos.module.ngfactory").then(m => m.ReembolsosModuleNgFactory), ɵ4 = () => import("./modules/pago-cotizaciones/detalle-cotizacion.module.ngfactory").then(m => m.DetalleCotizacionModuleNgFactory), ɵ5 = () => import("./modules/certificados/certificados.module.ngfactory").then(m => m.CertificadosModuleNgFactory), ɵ6 = () => import("./modules/devolucion-excesos/devolucion-excesos.module.ngfactory").then(m => m.DevolucionExcesosModuleNgFactory), ɵ7 = () => import("./modules/pagobonos/pagobonos.module.ngfactory").then(m => m.PagobonosModuleNgFactory), ɵ8 = () => import("./modules/licencias/licencias.module.ngfactory").then(m => m.LicenciasModuleNgFactory), ɵ9 = () => import("./modules/ex-clientes/ex-clientes.module.ngfactory").then(m => m.ExClientesModuleNgFactory);
const routes = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: '',
        loadChildren: ɵ0
    },
    {
        path: 'menu',
        component: MenuComponent
    },
    {
        path: 'venta-bonos',
        loadChildren: ɵ1
    },
    {
        path: 'bono-ges',
        loadChildren: ɵ2
    },
    {
        path: 'reembolso',
        loadChildren: ɵ3
    },
    {
        path: 'pago-cotizaciones',
        loadChildren: ɵ4
    },
    {
        path: 'certificados',
        loadChildren: ɵ5
    },
    {
        path: 'devolucion-exceso',
        loadChildren: ɵ6
    },
    {
        path: 'pago-bonos',
        loadChildren: ɵ7,
    },
    {
        path: 'licencias',
        loadChildren: ɵ8
    },
    {
        path: '',
        loadChildren: ɵ9
    },
    {
        path: '**',
        redirectTo: ''
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9 };
